// extracted by mini-css-extract-plugin
export var gridImgTextContainer = "successFactor-module--gridImgTextContainer--oAj7Z";
export var mainContentWrapper = "successFactor-module--mainContentWrapper--lIkQU";
export var pageBuilder = "successFactor-module--pageBuilder--IRxWS";
export var pageBuilderTextImage = "successFactor-module--pageBuilderTextImage--UfET+";
export var richText = "successFactor-module--richText--Q-VFH";
export var sideMenu = "successFactor-module--sideMenu--jdP9H";
export var textImage = "successFactor-module--textImage--XwExb";
export var videoEmbed = "successFactor-module--videoEmbed--8NVVP";